import { render, staticRenderFns } from "./BulkOperationsDialog.vue?vue&type=template&id=0be39d05"
import script from "./BulkOperationsDialog.vue?vue&type=script&lang=js"
export * from "./BulkOperationsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports